
//
// Flash Alert
//
// Dismiss function for flash alert boxes.
//

module.exports = function ($host, config) {

  // Config

  var dismissTime = 200;


  // Dom

  var $close = $('[data-dismiss]', $host);


  // Functions

  function marginBottom ($el) {
    return parseInt($host.css('margin-bottom'), 10) || 0;
  }

  function swipeAway (a) {
    this.style.transform = 'translateX(' + -200 * (1 - a * a) + 'px)';
  }

  function dismiss () {
    var $next  = $host.next();

    if ($next.length) {
      dismissAndAdjustNext($host, $next);
    } else {
      dismissSelf($host);
    }
  }

  function dismissSelf ($self) {
    var height = $host.outerHeight() + marginBottom($host);

    $self.animate({
      opacity: 0
    }, {
      ease:     'linear',
      step:     swipeAway,
      duration: dismissTime
    });

    delay(dismissTime/2000, function () {
      $self.animate({
        marginBottom: -height * 2/3
      }, {
        duration: dismissTime,
        complete: function () { $self.remove(); }
      });
    });

  }

  function dismissAndAdjustNext ($self, $next) {
    var height = $host.outerHeight() + marginBottom($host);

    $self.animate({
      opacity: 0
    }, {
      ease:     'linear',
      step:     swipeAway,
      duration: dismissTime
    });

    $next.delay(dismissTime/2).animate({
      marginTop: -height
    }, {
      duration: dismissTime,
      complete: function () {
        $self.remove();
        $next.css({ marginTop: 0 });
      }
    });
  }


  // Listeners

  $close.on('click', dismiss);
  $(document).on('keydown', whichKey(27, dismiss));

};

